export function downloadCSV(csvString: string, csvName: string) {
  const blob = new Blob([csvString], {
    type: 'text/csv;charset=utf-8;',
  });
  downloadBlob(blob, csvName);
}

export function downloadBlob(blob: Blob, filename: string) {
  if ('msSaveBlob' in navigator) {
    // @ts-ignore
    navigator.msSaveBlob(blob, filename);
  } else {
    const link = document.createElement('a');
    const url = URL.createObjectURL(blob);

    link.setAttribute('href', url);
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();

    setTimeout(() => {
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    });
  }
}
